export default "__VITE_ASSET__Cp2nsvll__"